export const HIPAA_BENEFITS: string[] = [
  'One Custom Link for All Visits',
  'Real-Time Virtual Waiting Room',
  'Private Sessions (1:1)',
  'Group Sessions (Up to 15 People)',
  'AI-Powered Progress Notes',
  'Screen Sharing, Chat & File Sharing',
  'Virtual Whiteboard',
  'EMDR Therapy Tools Included',
  'HIPAA Secure with No Dropped Calls',
  'Scales with Your Practice',
  'No Downloads Required',
];
